window.heroSectionsInit = function(sectionId) {
  const section = document.getElementById(sectionId);
  if (!section) return;
  
  const buttonWrapper = section.querySelector('[data-hero-button]');
  if (!buttonWrapper) return;
  
  console.log('✅ Initializing hero section:', sectionId);
  
  // Observer that triggers EVERY TIME section is visible
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        console.log('🎯 Section visible - showing button');
        buttonWrapper.classList.add('show');
      } else {
        console.log('🙈 Section hidden - hiding button');
        buttonWrapper.classList.remove('show');
      }
    });
  }, {
    threshold: 0.1,  // Trigger at 10% visibility
    rootMargin: '0px 0px -30% 0px'  // Start earlier
  });
  
  observer.observe(section);
};

// Auto-init ALL hero sections
document.addEventListener('DOMContentLoaded', function() {
  console.log('🔄 Initializing all hero sections...');
  document.querySelectorAll('.image-button-hero').forEach(section => {
    window.heroSectionsInit(section.id);
  });
});

// Re-init for Shopify dynamic sections
document.addEventListener('shopify:section:load', function() {
  document.querySelectorAll('.image-button-hero').forEach(section => {
    const sectionId = section.id;
    // Re-init only if not already initialized
    if (!section.dataset.initialized) {
      window.heroSectionsInit(sectionId);
      section.dataset.initialized = 'true';
    }
  });
});
